import {
  ALL_FEATURES_OFF,
  FEATURE_FLAG_KEYS,
  type FeatureFlagMap,
} from "../../../shared/lib/featureFlags.js"

/** Anything that isn't an explicit `true` from the server reads as off. */
export function normalizeFeatureFlags(raw: unknown): FeatureFlagMap {
  const flags = (raw as { flags?: Record<string, unknown> } | null)?.flags
  if (!flags || typeof flags !== "object") return { ...ALL_FEATURES_OFF }

  const result = { ...ALL_FEATURES_OFF }
  for (const key of FEATURE_FLAG_KEYS) {
    result[key] = flags[key] === true
  }
  return result
}
